import { render, staticRenderFns } from "./quotationList.vue?vue&type=template&id=7da400a4&"
import script from "./quotationList.vue?vue&type=script&lang=ts&"
export * from "./quotationList.vue?vue&type=script&lang=ts&"
import style0 from "./quotationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports